export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8932.f6a97c65.jpg";